<template>
  <v-card v-if="model && model.id">
    <v-row
      no-gutters
      class="px-4"
    >
      <v-col
        cols="12"
        class="px-3 py-3"
        :sm="12"
        :md="6"
      >
        <v-col
          cols="12"
          class="py-0 my-0"
          :sm="12"
        >
          <div class="wbd-label-text">
            {{ 'Другой подписант в договоре' }}
          </div>
        </v-col>
        <v-col
          cols="12"
          class="py-0 my-0"
          :sm="12"
        >
          <div>{{ model.fullName }}</div>
        </v-col>
      </v-col>
      <v-col
        cols="12"
        class="px-3 py-3"
        :sm="12"
        :md="6"
      >
        <v-col
          cols="12"
          class="py-0 my-0"
          :sm="12"
        >
          <div class="wbd-label-text">
            {{ 'Должность' }}
          </div>
        </v-col>
        <v-col
          cols="12"
          class="py-0 my-0"
          :sm="12"
        >
          <div>{{ model.profession }}</div>
        </v-col>
      </v-col>
      <v-col
        cols="12"
        class="px-3 py-3"
        :sm="12"
        :md="6"
      >
        <v-col
          cols="12"
          class="py-0 my-0"
          :sm="12"
        >
          <div class="wbd-label-text">
            {{ 'Основание полномочий' }}
          </div>
        </v-col>
        <v-col
          cols="12"
          class="py-0 my-0"
          :sm="12"
        >
          <div>{{ model.authority }}</div>
        </v-col>
      </v-col>
    </v-row>
    <v-row
      v-if="model.procuration && model.procuration.id"
      no-gutters
      class="px-4"
    >
      <v-col
        cols="12"
        class="px-3 py-3"
        :sm="12"
        :md="6"
      >
        <v-col
          cols="12"
          class="py-0 my-0"
          :sm="12"
        >
          <div class="wbd-label-text">
            {{ 'Номер доверенности' }}
          </div>
        </v-col>
        <v-col
          cols="12"
          class="py-0 my-0"
          :sm="12"
        >
          <div>{{ model.procuration.number }}</div>
        </v-col>
      </v-col>
      <v-col
        cols="12"
        class="px-3 py-3"
        :sm="12"
        :md="6"
      >
        <v-col
          cols="12"
          class="py-0 my-0"
          :sm="12"
        >
          <div class="wbd-label-text">
            {{ 'Дата выдачи доверенности' }}
          </div>
        </v-col>
        <v-col
          cols="12"
          class="py-0 my-0"
          :sm="12"
        >
          <div>{{ renderDateTime(model.procuration.dateOfIssue) }}</div>
        </v-col>
      </v-col>
      <v-col
        cols="12"
        class="px-3 py-3"
        :sm="12"
        :md="6"
      >
        <v-col
          cols="12"
          class="py-0 my-0"
          :sm="12"
        >
          <div class="wbd-label-text">
            {{ 'Срок действия доверенности' }}
          </div>
        </v-col>
        <v-col
          cols="12"
          class="py-0 my-0"
          :sm="12"
        >
          <div>{{ renderDateTime(model.procuration.validUntil) }}</div>
        </v-col>
      </v-col>
    </v-row>
  </v-card>
  <span v-else> {{ '' }}</span>
</template>
<script>

import { offerDate } from '@/utils/dateUtl'

export default {
  name: 'OrganizationSignatoryAuthority',
  components: { },

  validations: {
    organization: {
    }
  },
  props: {
    model: {
      type: Object,
      default: () => ({
        'id': undefined,
        'profession': undefined,
        'fullName': undefined,
        'procuration': {
          'id': undefined,
          'number': undefined,
          'dateOfIssue': undefined,
          'validUntil': undefined
        },
        'authority': undefined,
        'createdAt': undefined
      })
    }
  },
  data: () => ({
    // model: {
    //   'id': '9d6564a8-7917-4545-b05a-a5be343d2c12',
    //   'profession': 'Директор по персоналу',
    //   'fullName': 'Кислова Людмила Викторовна',
    //   'procuration': {
    //     'id': '2969488d-7933-49b8-8f75-6996c58b4cbb',
    //     'number': null,
    //     'dateOfIssue': '2022-03-05T00:00:00+00:00',
    //     'validUntil': '2025-01-31T23:59:59+00:00'
    //   },
    //   'authority': 'Доверенность',
    //   'createdAt': '2023-07-12T20:13:13+00:00'
    // }
  }),
  computed: {

  },
  watch: {

  },

  created () {
  },
  methods: {
    renderDateTime (date) {
      if (!date) {
        return ''
      }
      return offerDate(date, 'DD MMMM YYYY')
    }
  }
}
</script>


